import { isDefined } from '@grandvisionhq/utils';

// Convert from the Graph key to the CommerceTools key
const specificationDictionary = {
    accessoryColor: 'accessoryColor',
    articleNumber: 'articleNumber',
    brand: 'brand',
    erpId: 'erpId',
    faceShape: 'faceShape',
    frameColor: 'frameColor',
    frameMaterial: 'frameMaterial',
    frameShape: 'frameShape',
    frameType: 'frameType',
    frameSize: 'frameSize',
    isGlazeble: 'glazeble',
    lensColor: 'lensColor',
    material: 'material',
    opcoBackendId: 'opcoBackendId',
    isPolarized: 'polarized',
    prescriptionGlass: 'prescriptionGlass',
    roadworthiness: 'roadworthiness',
    supplierEAN: 'supplierEAN',
    targetGender: 'gender',
    templeType: 'templeType',
    trend: 'trend',
    segment: 'segment'
};
const getSpecificationItems = (serverSpecifications)=>{
    const clientSpecifications = Object.entries(serverSpecifications).map(([graphKey, value])=>{
        const specificationAttribute = specificationDictionary[graphKey];
        if (!specificationAttribute || value === null || value === undefined || value === '' || Array.isArray(value) && value.length === 0) {
            return undefined;
        }
        return {
            specificationAttribute,
            value
        };
    });
    return clientSpecifications.filter(isDefined);
};

export { getSpecificationItems };
//# sourceMappingURL=get-specification-items.js.map
